module.exports = __webpack_public_path__ + "static/img/products4.f705cc19.png";